
<template>
    <section class="container columns" style="margin: 2% auto">
        <form v-on:submit.prevent="createProduct" class="column is-half">
            <b-field label="Product Name">
              <b-input v-model="newProduct.title" placeholder required></b-input>
            </b-field>
            <b-field label="Product Categories">
              <b-input v-model="newProduct.categories" placeholder required></b-input>
            </b-field>
            <b-field label="Product Type">
              <b-input v-model="newProduct.type"  required></b-input>
            </b-field>
            <b-field label="Product Description">
              <b-input type="textarea" v-model="newProduct.desc"  required></b-input>
            </b-field>
            <b-field label="Product Price">
              <b-input v-model="newProduct.price"  required></b-input>
            </b-field>
            <b-field label="Product Image">
              <!-- <b-file-input v-model="newProduct.img" file  required></b-file-input> -->
            </b-field>
            <div class="productImage"><input type="file" @change="previewFiles" v-on:change="newProduct.price" multiple/></div>
            <div>
            
                <button class="button is-primary" type="submit">Create</button>
            </div>
        </form>
    </section>
</template>

<script>
import { currencies } from '@/helpers';
import { mapGetters } from 'vuex';

export default {
    name: "newProduct",
    data() {
      return {

        newProduct: {
          productName: '',
          cropTradeName: '',
          cropMaturity: '',
        },
      };
    },
    created() {
    },
    methods: {
      createProduct() {
        const loading = this.$loading.open();

        this.$store.dispatch('createProduct', this.newProduct).then(newProduct=> {
          loading.close();
          this.$router.push({productName: "Product Names"})
          this.$toasted.global.success('Product Successfully Created!')
        }).catch(e=> {
          console.log('Exception when creating new crop', e);
          loading.close();
          this.$toasted.global.error('Failed to create crop .');
        })
      }

    }
}


</script>

<style scoped>
.productImage{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Shop/NewProduct.vue